import { useEffect, useState } from "react";
import { CloudOff, Download, Trash2, WifiOff, Check } from "lucide-react";
import { toast } from "sonner";
import { getOfflineModule, removeModuleOffline, saveModuleOffline } from "@/lib/offline";
import { track } from "@/lib/track";
import { usePrefs } from "@/context/PrefsContext";

export function OfflineBanner({ synced }) {
  const { prefs } = usePrefs();
  const jp = prefs.lang === "jp";
  return (
    <div className="flex items-center gap-2 rounded-xl border border-amber-300 bg-amber-50 px-4 py-2.5 text-xs text-amber-900 dark:bg-amber-950/40 dark:text-amber-200" data-testid="offline-banner">
      <WifiOff className="h-4 w-4 shrink-0" />
      <span>{jp ? "オフラインモード：保存済みの教材を表示しています。" : "Mode offline: menampilkan materi yang tersimpan di perangkat."}{synced === false && (jp ? " 回答はオンライン復帰時に同期されます。" : " Jawaban akan disinkronkan saat kembali online.")}</span>
    </div>
  );
}

export function OfflineSaveButton({ module }) {
  const { prefs } = usePrefs();
  const jp = prefs.lang === "jp";
  const [saved, setSaved] = useState(null);
  const [prog, setProg] = useState(null);
  useEffect(() => { getOfflineModule(module.id).then((r) => setSaved(Boolean(r))).catch(() => setSaved(false)); }, [module.id]);
  const toggle = async () => {
    if (saved) { await removeModuleOffline(module.id); setSaved(false); toast.success(jp ? "オフライン保存を削除しました" : "Modul dihapus dari penyimpanan offline"); return; }
    setProg({ d: 0, n: 1 });
    try { await saveModuleOffline(module, (d, n) => setProg({ d, n })); setSaved(true); track("offline_save", { module_id: module.id }); toast.success(jp ? "オフラインで学習できます（教材・ミニテスト・音声）" : "Tersimpan — materi, mini test & audio bisa dibuka tanpa sinyal"); } catch (e) { toast.error(jp ? "保存に失敗しました" : "Gagal menyimpan offline"); }
    setProg(null);
  };
  if (saved === null) return null;
  return (
    <button data-testid="offline-save-button" data-saved={saved} onClick={toggle} disabled={!!prog} className={`inline-flex min-h-9 items-center gap-1.5 rounded-full border px-3 py-1.5 text-xs font-semibold transition-colors ${saved ? "border-sage/40 bg-sage-soft text-sage" : "border-border hover:bg-accent"} disabled:opacity-60`}>
      {prog ? <><Download className="h-3.5 w-3.5 animate-bounce" />{jp ? "保存中" : "Menyimpan"} {prog.d}/{prog.n}</> : saved ? <><Check className="h-3.5 w-3.5" />{jp ? "オフライン保存済み" : "Tersimpan offline"}<Trash2 className="ml-1 h-3 w-3 opacity-60" /></> : <><CloudOff className="h-3.5 w-3.5" />{jp ? "オフライン保存" : "Simpan offline"}</>}
    </button>
  );
}
